import { sharedSchema } from "@shared-database/pgSchema";
import {
  timestampColumns,
  leoNotNullForeignID,
  leoEnum,
} from "@shared-database/utils";
import { integer, primaryKey, text, index } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import type { z } from "zod";
import { User } from "./user";

export const ThemeModeEnumValues = ["dark", "light"] as const;
export type ThemeMode = (typeof ThemeModeEnumValues)[number];

export const ThemeModeEnum = leoEnum("ThemeMode", ThemeModeEnumValues);

export const Account = sharedSchema.table(
  "Account",
  {
    // Mixins
    ...timestampColumns,

    // Properties
    userId: leoNotNullForeignID("userId").references(() => User.id, {
      onDelete: "cascade",
    }),
    type: text("type").notNull(),
    provider: text("provider").notNull(),
    providerAccountId: text("providerAccountId").notNull(),
    refresh_token: text("refresh_token"),
    access_token: text("access_token"),
    expires_in: integer("expires_in"),
    expires_at: integer("expires_at"),
    ext_expires_in: integer("ext_expires_in"),
    token_type: text("token_type"),
    scope: text("scope"),
    id_token: text("id_token"),
    session_state: text("session_state"),
    themeMode: ThemeModeEnum("themeMode"),
  },
  (table) => [
    primaryKey({
      columns: [table.provider, table.providerAccountId],
    }),
    index("Account_userIdIdx").on(table.userId),
    index("Account_userId_provider_idx").on(table.userId, table.provider),
  ],
);
export const insertAccountSchema = createInsertSchema(Account);
export type InsertAccountType = z.infer<typeof insertAccountSchema>;
